export const headerStyle = {
  backgroundColor: "rgb(20 37 103 / 10%)",
  color: "#000000",
  fontWeight: "700",
  padding: "12px 20px",
};
